import axios from "axios";
import Vue from "vue";
import { BASEURL } from "@/config/index";
import cookieType from "@/config/cookieType";
import notification from "ant-design-vue/es/notification";

export default () => {
  const instance = axios.create({
    baseURL: BASEURL
  });

  Vue.cookie.get(cookieType.MCHASHID)
    ? (instance.defaults.headers.common["Authorization"] = Vue.cookie.get(
      cookieType.MCHASHID
    ))
    : undefined;
  instance.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

  instance.interceptors.response.use(
    function (response) {
      // Do something with response data
      return response;
    },
    function (error) {
      // Do something with response error
      if (!error["response"]) {
        if (status) {
          showErrorMessage("Your authorization token is invalid or expired");
          // redirect to auth page or login again
          window.location.replace("/login");
        }

        return Promise.reject(error);
      } else if (error.response.status == 403) {
        showErrorMessage("Your authorization token is invalid or expired");
        // redirect to auth page or login again
        window.location.replace("/login");
      } else if (error.response.status == 401) {
        // store.dispatch("Account/onLogoutUser")
        window.location.replace("/login");
        // router.push({
        //   path: "/login"
        // });
        showErrorMessage(
          "Something went wrong. kindly contact your administrator"
        );
      } else {
        // showErrorMessage(
        //   "Something went wrong. kindly contact your administrator"
        // );
      }
      return Promise.reject(error.response);
    }
  );
  return instance;
};

const showErrorMessage = message => {
  notification.error({
    message: "Oops!",
    description: message
  });
};



// WEBPACK FOOTER //
// ./src/apiServices/Api.js